<template>
  <b-modal id="createOrganizationModal" ref="createOrganizationModal" @close="resetModal">
    <template slot="modal-title">{{ $t('createOrganization') }}</template>
    <b-form>
      <fieldset :disabled="createLoading">
        <details-form :fields="organizationFormFields()" :state-object="organization"/>
      </fieldset>
    </b-form>

    <div slot="modal-footer" class="col-md-12">
      <b-form>
        <fieldset :disabled="createLoading">
          <b-button variant="primary" class="float-lg-right" @click="createOrganization" :disabled="validate">{{ $t('create') }}</b-button>
          <b-button variant="secondary" class="float-lg-left" v-on:click="resetModal">{{ $t('cancel') }}</b-button>
        </fieldset>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
  import { mapGetters } from 'vuex'
  import DetailsForm from '../../components/DetailsForm'
  import BaseComponent from '../../components/BaseComponent'

  export default {
    name: 'CreateOrganizationModal',
    extends: BaseComponent,
    components: {
      DetailsForm
    },
    data () {
      return {}
    },
    computed: {
      ...mapGetters('organizations', ['createLoading', 'organization']),
      validate () {
        return !(
          this.organization.name && this.organization.organizationNumber &&
          this.organization.organizationNumber.length >= 3 && this.organization.organizationNumber.length <= 13)
      }
    },
    methods: {
      organizationFormFields () {
        return [
          { type: 'text', width: 12, name: 'name', autofocus: true },
          { type: 'text', width: 12, name: 'organizationNumber', placeholder: this.$t('requiredOrganizationNumberLength') }
        ]
      },
      resetModal () {
        this.$store.dispatch('licenses/resetCreateLicense')
        this.$refs['createOrganizationModal'].hide()
      },
      createOrganization () {
        this.$store.state.organizations.organization.organizationSource = 'LOCAL'
        this.$store.state.organizations.organization.active = true
        this.$store.state.organizations.organization.school = true
        this.$store.state.organizations.organization.schoolOwner = false

        this.$store.dispatch('organizations/create')
          .then(() => {
            this.$router.push('/organizations/' + this.$store.state.organizations.organization.organizationNumber)
          })
      }
    },
    i18n: {
      messages: {
        en: {
          'requiredOrganizationNumberLength': 'Enter between 3 and 13 lettters'
        },
        nb: {
          'requiredOrganizationNumberLength': 'Skriv inn mellom 3 og 13 tegn'
        }
      }
    }
  }
</script>